import { Component } from '@angular/core';

@Component({
  selector: 'app-wordpress',
  templateUrl: './wordpress.component.html',
  styleUrl: './wordpress.component.scss'
})
export class WordpressComponent {

}
